import React from 'react';
import ActionButton from "../../../../Components/Buttons/ActionButton";
import { DAYS_OF_THE_WEEK } from "../../../../Helpers/DateTimeHelper";
import { useClipboard } from "../../../../Hooks/Clipboard/useClipboard";
import { PropTypes } from "prop-types";

const getAvailabilityInputValue = (day, currentSlots) => {
    if (Object.keys(currentSlots).includes(day) && currentSlots[day].length > 0) {
        return currentSlots[day].filter(slot => slot);
    }
    return [];
}

const AvailabilityAssistanceButton = (props) => {
    const { clipboard, setClipboard } = useClipboard();

    const thisDaySlots = getAvailabilityInputValue(props.day, props.allAvailability);

    const handleMenuItemClick = (menuItem) => {

        switch (menuItem) {
            case 'copy': {
                setClipboard(thisDaySlots);
                break;
            }

            case 'paste': {
                if (clipboard) {
                    onChangeDay(props.day, clipboard)
                }
                break;
            }

            case 'copyDays': {
                onChangeWeek(thisDaySlots ?? []);
                break;
            }

            case 'copyWeekdays': {
                let updatedAvailability = {};
                for (let day of DAYS_OF_THE_WEEK) {
                    updatedAvailability[day] = (!['saturday', 'sunday'].includes(day))
                        ? thisDaySlots ?? []
                        : props.allAvailability[day] ?? [];
                }
                props.onAvailibilityChange(updatedAvailability);

                break;
            }

            case 'setFullDay': {
                onChangeDay(props.day, ['00:00-23:59']);
                break;
            }

            case 'set3Slot': {
                onChangeDay(props.day, ['00:00-02:00', '08:00-13:00', '14:00-23:59']);
                break;
            }

            case 'clearDay': {
                onChangeDay(props.day, []);
                break;
            }

            case 'clearWeek': {
                onChangeWeek([]);
                break;
            }

            default:
                alert(`Unknown menu option selected "${menuItem}"`);
                break;
        }
    }

    const onChangeDay = (changeDay, changeSlots) => {
        let updatedAvailability = {};
        for (let day of DAYS_OF_THE_WEEK) {
            updatedAvailability[day] = (day === changeDay)
                ? changeSlots
                : props.allAvailability[day] ?? [];
        }
        props.onAvailibilityChange(updatedAvailability);
    }

    const onChangeWeek = (changeSlots) => {
        let updatedAvailability = {};
        for (let day of DAYS_OF_THE_WEEK) {
            updatedAvailability[day] = changeSlots;
        }
        props.onAvailibilityChange(updatedAvailability);
    }
    return (
        <ActionButton
            className="clear tiny margin-0"
            icon={'fa-cog'}
            menuItems={{
                copy: 'Copy',
                paste: 'Paste',
                copyDays: 'Copy to all days',
                copyWeekdays: 'Copy to all weekdays',
                divider1: 'divider',
                setFullDay: 'Set full day availability',
                //set3Slot: 'Set full day with night closure & luncheon',
                divider2: 'divider',
                clearDay: 'Clear day',
                clearWeek: 'Clear whole week',
            }}
            onMenuItemClick={handleMenuItemClick}
        />
    )
}

AvailabilityAssistanceButton.propTypes = {
    day: PropTypes.string,
    allAvailability: PropTypes.object,
    onAvailibilityChange: PropTypes.func,
}

export default AvailabilityAssistanceButton;
